class RoleAssignment {
    appId = "";
    appName = "";
    roleName = "";
    source = "";
    fullName = "";
    canRevoke = false;
}

export default RoleAssignment;